<template>
  <div>
    <!-- 表单 -->
    <a-form :form="editForm" @submit="handleSubmit" autocomplete="off" class="ant-advanced-search-form">
      <a-row :gutter="10">
        <!-- Last Name -->
        <a-col :xs="24" :lg="3">
          <a-form-item label="Last">
            <a-input
              @change="handleNameChange"
              v-decorator="[
                'lastName',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Please input Last Name.',
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
        </a-col>
        <!-- First Name -->
        <a-col :xs="24" :lg="3">
          <a-form-item label="First">
            <a-input 
              @change="handleNameChange"
              v-decorator="[
                'firstName',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Please input First Name.',
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
        </a-col>
        <!-- Middle Name -->
        <a-col :xs="24" :lg="3">
          <a-form-item label="Middle">
            <a-input
              @change="handleNameChange"
              v-decorator="[
                'middleName',
                {
                  rules: [
                    {
                      required: false,
                      message: 'Please input Middle Name.',
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
        </a-col>
        <!-- Nickname -->
        <a-col :xs="24" :lg="4">
          <a-form-item label="Nickname">
            <a-input
              @change="handleNickNameChange"
              v-decorator="[
                'preferToBeCalled',
                {
                  rules: [
                    {
                      required: false,
                      message: 'Please input prefer to be called.',
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
        </a-col>
        <!-- gender -->
        <a-col :xs="24" :lg="3">
          <a-form-item label="Gender">
            <a-select
              v-decorator="[
                'gender',
                { rules: [{ required: true, message: 'Please select your Gender!' }] },
              ]"
            >
              <a-select-option v-for="g in genderList" :key="'gender-' + g.code" :value="g.code">{{ g.enName }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- Title -->
        <a-col :xs="24" :lg="3">
          <a-form-item label="Title">
            <a-select
              v-decorator="[
                'title',
                { rules: [{ required: false, message: 'Please select your title!' }] },
              ]"
            >
              <a-select-option v-for="t in titleList" :key="'title-' + t.code" :value="t.code">{{ t.enName }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- 生日 -->
        <a-col :xs="24" :lg="4">
          <a-form-item
            label="DOB"
            :validateStatus="birthdayValid.status"
            :help="birthdayValid.help"
          >
            <a-input
              placeholder="mm/dd/yyyy"
              :maxLength="10"
              @change="handleDateChange(null, null, $event)"
              @blur="handleCustomerBirthdayBlur"
              v-decorator="[
                'birthday',
                  { 
                    rules: [{ required: true }]
                  },
              ]" 
            />
            <!-- <a-date-picker
              format="MM/DD/YYYY"
              v-decorator="[
              'birthday', 
              {
                rules: [{ required: true, message: 'Please input your birthday!' }],
              },
              ]" /> -->
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="10">
        <!-- Language -->
        <a-col :xs="24" :lg="6">
          <a-form-item label="Primary Language">
            <a-select
              :showSearch="true"
              optionFilterProp="children"
              v-decorator="[
                'languages',
                {rules: [{ required: false, message: 'Please select Language' }]}
              ]"
              :showArrow="true"
            >
              <a-select-option v-for="i in languageList" :key="'languages-' + i.code" :value="i.code">{{ i.enName }} ({{ i.lgCode }})</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- background -->
        <a-col :xs="24" :lg="4">
          <a-form-item label="Origin">
            <a-select
              :showSearch="true"
              optionFilterProp="children"
              v-decorator="[
                'nationalBackground',
                {rules: [{ required: false, message: 'Please select Background' }]}
              ]"
              :showArrow="true"
            >
              <a-select-option v-for="i in backgroundList" :key="'background-' + i.code" :value="i.code">{{ i.enName }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <!-- ethnicitiesId -->
        <a-col :xs="24" :lg="4">
          <a-form-item label="Ethnicities">
            <a-select
              :showSearch="true"
              :dropdownMatchSelectWidth="false"
              optionFilterProp="children"
              v-decorator="[
                'ethnicitiesId',
                {rules: [{ required: false, message: 'Please select Ethnicities' }]}
              ]"
              :showArrow="true"
            >
              <a-select-option v-for="i in ethnicitiesList" :key="'ethnicities-' + i.code" :value="i.code">{{ i.enName }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
         <!-- Company -->
        <a-col :xs="24" :lg="3">
          <a-form-item label="Company">
            <a-select
              v-decorator="[
                'companyCode',
                { rules: [{ required: true, message: 'Please select your Company!' }] },
              ]"
            >
              <a-select-option v-for="i in companyList" :key="'company-' + i.code" :value="i.code">{{ i.enName }}</a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :xs="24" :lg="3">
          <a-form-item label="Referral By">
            <a-input
              v-decorator="[
                'referralBy',
                {
                  rules: [
                    {
                      required: false,
                      message: 'Please input referral By.',
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
        </a-col>
        <a-col :xs="24" :lg="3">
          <a-form-item label="Referral Others">
            <a-input
              v-decorator="[
                'referralByOthers',
                {
                  rules: [
                    {
                      required: false,
                      message: 'Please input referral Others.',
                    },
                  ],
                },
              ]"
            />
          </a-form-item>
        </a-col>
      </a-row>
      <a-row :gutter="10">
        <!-- 邮箱 -->
        <a-col :xs="24" :lg="12" class="email-space">
          <span class="text-span-title">Email：</span>
           <!-- *************************** 多个邮箱开始 ***************************** -->
          <div v-for="(p, pindex) in contactList" :key="'contact-row-email-' + pindex" >
            <template v-if="p.contactType === '1'" >
             <div class="flex" style="margin-bottom:5px;">
                <a-form-item>
                  <a-select
                    @change="(value) => { handleSortNumUpdata(value, pindex) }"
                    style="width: 46px;"
                    class="qx-radius-right"
                    v-decorator="[
                      'contact-' + pindex + '-sortnum',
                      { 
                        initialValue: contactList[pindex].sortNum,
                        rules: [{ required: true }] },
                    ]">
                    <template v-for="(item, aindex) in contactEmailList">
                      <a-select-option
                        :value="aindex + 1"
                        :key="'contact-email-sortnum-' + aindex"
                        v-if="contactList[pindex].sortNum !== (aindex + 1)"
                      >{{ aindex + 1 }}
                      </a-select-option>
                    </template>
                  </a-select>
               </a-form-item>
               <a-form-item style="flex:1;" class="phone-number-extension">
                  <a-input
                    class="contact-email qx-radius"
                    @change="handleMultiEmailUpdata($event, pindex)"
                    v-decorator="[
                    'contact-' + pindex + '-email',
                    {
                    initialValue: contactList[pindex].email,
                    rules: [
                      {
                        type: 'email',
                        message: 'Please enter a valid email!',
                      },
                      {
                        required: false,
                        message: 'Please input your email!',
                      },
                    ],
                    validateTrigger: 'blur',
                    },
                  ]"
                  />
                </a-form-item>
                <a-form-item>
                  <a-select
                    @change="(value) => { handleTagCodeUpdata(value, pindex) }"
                    :dropdownMatchSelectWidth="false"
                    class="cdb-email-select phone-number-extension qx-radius-left"
                    style="width: 90px;"
                    optionFilterProp="children"
                    v-decorator="[
                      'contact-' + pindex + '-tagCode',
                      { 
                        initialValue: p.tagCode,
                        rules: [{ required: false, message: 'Please select your email type' }] },
                    ]">
                      <a-select-option value="1">Personal</a-select-option>
                      <a-select-option value="2">Business</a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item>
                  <a style="padding-left: 10px;" class="cdb-email-add" @click="handleContactEmailAdd" v-if="firstContactEmailIndex === pindex"><a-icon type="plus"/></a>
                  <a-popconfirm
                    v-if="firstContactEmailIndex !== pindex"
                    title="Are you sure?"
                    ok-text="Yes"
                    cancel-text="No"
                    @confirm="handleContactDelete(pindex)"
                  >
                    <a style="padding-left: 10px;" class="cdb-email-add"><a-icon type="delete" /></a>
                  </a-popconfirm>
                </a-form-item>
             </div>
            </template>
          </div>
          <!-- *************************** 多个邮箱结束 ***************************** -->
        </a-col>
        <a-col :xs="24" :lg="12" style="padding-right: 0;" >
          <span class="text-span-title">Contact number：</span>
          <!-- *************************** 多个电话开始 ***************************** -->
          <template v-for="(p, pindex) in contactList" >
            <div v-if="p.contactType === '2'" :key="'contact-row-phone-' + pindex" class="flex contact-box" style="margin-bottom:5px;">
                <a-form-item>
                  <a-select
                    @change="(value) => { handleSortNumUpdata(value, pindex) }"
                    style="width: 46px;"
                    class="qx-radius-right"
                    v-decorator="[
                      'contact-' + pindex + '-sortnum',
                      { 
                        initialValue: contactList[pindex].sortNum,
                        rules: [{ required: true }] },
                    ]">
                    <template v-for="(item, aindex) in contactPhoneList">
                      <a-select-option
                        :value="aindex + 1"
                        :key="'contact-phone-sortnum-' + aindex"
                        v-if="contactList[pindex].sortNum !== (aindex + 1)"
                        >{{ aindex + 1 }}
                      </a-select-option>
                    </template>
                  </a-select>
                </a-form-item>
                <a-form-item class="phone-number-extension">
                  <a-select
                    @change="(value) => { handleTagCodeUpdata(value, pindex) }"
                    :dropdownMatchSelectWidth="false"
                    class="cdb-phone-select qx-radius"
                    style="width: 83px;margin-right: -2px;"
                    optionFilterProp="children"
                    v-decorator="[
                      'contact-' + pindex + '-tagCode',
                      { 
                        initialValue: p.tagCode,
                        rules: [{ required: false, message: 'Please select your phone type' }] },
                    ]"
                    >
                    <a-select-option value="1">Mobile</a-select-option>
                    <a-select-option value="2">Work</a-select-option>
                    <a-select-option value="3">Home</a-select-option>
                  </a-select>
                </a-form-item>
                <!--  -->
                <a-form-item style="flex:1;" :class="contactList[pindex].tagCode === '2' ? 'contact-phone-box' : ''">
                  <PhonenumberInput v-if="contactList[pindex].phoneNumberData" :required="false" :initData="contactList[pindex].phoneNumberData" @update="newValue => { handleContactPhoneNumberUpdata(pindex, newValue) }"/>
                </a-form-item>
                <a-form-item class="phone-number-extension ext-phone">
                  <a-input
                    v-show="contactList[pindex].tagCode === '2'"
                    @change="handleMultiPhoneExtUpdata($event, pindex)"
                    class="phoneExtInput qx-radius-left"
                    style="width: 70px;"
                    placeholder="Ext."
                      v-decorator="[
                        'contact-' + pindex + '-phoneExt',
                        {
                          initialValue: contactList[pindex].phoneExt,
                          rules: [{ required: false, message: 'Please input the Ext.' }],
                        }
                      ]"
                    />
                </a-form-item>
                <a-form-item>
                  <a style="padding-left: 10px;" class="cdb-email-add" @click="handleContactPhoneAdd" v-if="firstContactPhoneIndex === pindex">
                    <a-icon type="plus"/>
                  </a>
                  <a-popconfirm
                    v-if="firstContactPhoneIndex !== pindex"
                    title="Are you sure?"
                    ok-text="Yes"
                    cancel-text="No"
                    @confirm="handleContactDelete(pindex)"
                  >
                   <a style="margin-left:10px;line-height:32px;" class="cdb-contact-add" ><a-icon type="delete" /></a>
                  </a-popconfirm>
                </a-form-item>
            </div>
          </template>
        </a-col>
        <!-- *************************** 多个电话结束 ***************************** -->
      </a-row>
      <a-row>
        <cdb-address ref="addressComponent" :initData="addressList" @change="handleAddressChange"></cdb-address>
      </a-row>
      <a-row style="padding-bottom:10px;">
        <cdb-passport ref="passportComponent" :initData="passportList" :customerBirthday="editData.birthday" @change="handlePassportChange"></cdb-passport>
      </a-row>
      <a-row>
        <cdb-contact ref="emergencyContactComponent" :initData="emergencyContact"></cdb-contact>
      </a-row>
      <!-- 隐藏域 -->
      <a-form-item v-show="false"><a-input
        v-decorator="[
        'id',
        {rules: [{ required: false}]}
        ]"/>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import moment from 'moment'
import pick from 'lodash.pick'
import _ from 'lodash'
import CdbAddress from './CdbCustomerAddress'
import CdbPassport from './CdbCustomerPassport'
import CdbContact from './CdbCustomerContact'
import PhonenumberInput from '@/components/input/phonenumber/PhoneNumberInput'
import CustomerSummary from './CdbCustomerSummary'
import { Gender, Title, Company } from '@/utils/helper/standard-code-utils'
import { Language, Background, Ethnicities} from '@/utils/helper/dict-cdb-utils'

export default {
  name: 'CdbCustomerBasic',
  components: {
    PhonenumberInput,
    CdbAddress,
    CustomerSummary,
    CdbPassport,
    CdbContact
  },
  props: {
    initData: {
      type: [Object],
      default: null
    },
    initEmergencyContact: {
      type: [Object],
      required: true
    },
    countryList: {
      type: [Array],
      default: null
    }
  },
  data () {
    return {
      editForm: this.$form.createForm(this),
      editData: this.initData,
      visible: false,
      phoneNumberData: null,
      companyList: Company.dict,
      genderList: Gender.dict,
      titleList: Title.dict,
      backgroundList: [],
      ethnicitiesList: [],
      languageList: [],
      // 地址列表
      addressList: [],
      // 护照列表
      passportList: [],
      // 按钮
      contactList: [],
      // 紧急联系人
      emergencyContact: this.initEmergencyContact,
      // 客人生日是否有效,客人生日格式错误提示语
      birthdayValid: {
        status: 'success',
        help: ''
			}
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    // 初始化数据
    async loadData() {
      this.contactList = []
      const vueData = this.editData
      this.languageList = await Language.getDict()
      this.backgroundList = await Background.getDict()
      this.ethnicitiesList = await Ethnicities.getDict()
      if (vueData) {
        const editData = pick(vueData, ['id', 'firstName', 'lastName', 'middleName', 'gender', 'birthday', 'title', 'languages', 'nationalBackground', 'ethnicitiesId', 'companyCode', 'preferToBeCalled', 'referralBy', 'referralByOthers'])
        // 更换为手动输入不用转moment
        if (editData.birthday && editData.birthday !== '') {
          if (editData.birthday.indexOf('/') > 0) {
            editData.birthday = moment(editData.birthday, 'MM/DD/YYYY').format('MM/DD/YYYY')
          } else {
            editData.birthday = moment(editData.birthday).format('MM/DD/YYYY')
          }
        }
        // 新加联系方式
        let contactList = vueData.contactList
        if (!contactList || contactList.length == 0) {
          contactList = []
        } else {
          for (let i=0; i < contactList.length; i++) {
           const contact = contactList[i]
          if (!contact.tagCode) {
            contact.tagCode = ''
          }
          if (!contact.sortNum) {
            contact.sortNum = 1
          }
          // 处理电话号码
            if (contact.phoneNumber && contact.phoneNumber !== '') {
              contact.phoneNumberData = {
                  countryCode: contact.phoneCountryCode ? contact.phoneCountryCode : 'US',
                  countryCallingCode: contact.phoneCountryCallingCode,
                  isValid: true,
                  phoneNumber: contact.phoneNumber
              }
            } else {
              contact.phoneNumberData = {
                  countryCode: 'US',
                  countryCallingCode: '1',
                  isValid: false,
                  phoneNumber: ''
                }
            }
          }
        }
        if (contactList.length === 0 || contactList.filter(item => { return item.contactType === '1' }).length === 0) {
          contactList.push({ tagCode: '', sortNum: 1, contactType: '1', email: '' })
        }
        if (contactList.length === 0 || contactList.filter(item => { return item.contactType === '2' }).length === 0) {
          contactList.push({ tagCode: '', sortNum: 1, contactType: '2', phoneNumberData: { countryCode: 'US', countryCallingCode: '1', phoneNumber: '', isValid: true }, phoneExt: null })
        }
        this.contactList = contactList
        // 
        let phoneNumberData = null
        // 处理电话号码
        if (vueData.phoneNumber && vueData.phoneNumber !== '') {
          phoneNumberData = {
            countryCode: vueData.phoneCountryCode ? vueData.phoneCountryCode : 'US',
            countryCallingCode: vueData.phoneCountryCallingCode,
            isValid: false,
            phoneNumber: vueData.phoneNumber
          }
        } else {
            phoneNumberData = {
              countryCode: 'US',
              countryCallingCode: '1',
              isValid: false,
              phoneNumber: ''
            }
        }
        this.$nextTick(() => {
          this.editForm.setFieldsValue(editData)
          this.phoneNumberData = phoneNumberData
        })
        this.addressList = vueData.addressList
        this.passportList = vueData.passportList
      }
    },
    // 处理了名字变化
    handleNameChange (e) {
      const value = e.target.value
      if (value && value !== '') {
        let newValue = value.replace(/[^a-zA-Z ]/g, '')
        if (newValue !== '') {
          let newValueArrey = newValue.split(' ')
          newValueArrey = newValueArrey.map(n => {
            return _.capitalize(n)
          })
          newValue = newValueArrey.join(' ')
        }
        e.target.value = newValue
      }
    },
    handleNickNameChange (e) {
      const value = e.target.value
      if (value && value !== '') {
      let newValue = value.replace(/[^a-zA-Z \u4e00-\u9fa5]/g, '')
        if (newValue !== '') {
          let newValueArrey = newValue.split(' ')
          newValueArrey = newValueArrey.map(n => {
            return _.capitalize(n)
          })
          newValue = newValueArrey.join(' ')
        }
        e.target.value = newValue
      }
    },
    handleSubmit (e) {
      e.preventDefault()
    },
    // 添加联系邮件
    handleContactEmailAdd () {
     this.contactList.push({ email: null, contactType: '1', tagCode: '', sortNum: (this.contactEmailList.length + 1)})
    },
    // 添加联系电话
    handleContactPhoneAdd () {
      this.contactList.push({ contactType: '2', phoneNumberData: { isValid: true }, phoneExt: null, tagCode: '', sortNum: (this.contactPhoneList.length + 1) })
    },
    // 监控邮箱输入变化
    handleMultiEmailUpdata (e, pindex) {
      if (this.contactList && this.contactList.length > 0) {
        const newValue = e.target.value
        const contact = this.contactList[pindex]
        contact.email = newValue
        this.$set(this.contactList, pindex, contact)
      }
    },
    // 监控分机号输入变化
    handleMultiPhoneExtUpdata (e, pindex) {
      if (this.contactList && this.contactList.length > 0) {
        const newValue = e.target.value
        const contact = this.contactList[pindex]
        contact.phoneExt = newValue
        this.$set(this.contactList, pindex, contact)
      }
    },
    // 联系方式标签类型变化
    handleTagCodeUpdata (value, pindex) {
      if (this.contactList && this.contactList.length > 0) {
        const newValue = value
        const contact = this.contactList[pindex]
        contact.tagCode = newValue
        this.$set(this.contactList, pindex, contact)
      }
    },
    // SortNum变化
    handleSortNumUpdata (value, pindex) {
      const contactList = this.contactList
      const currentContact = contactList[pindex]
      for(let i=0; i<contactList.length; i++) {
        const c = contactList[i]
        if (currentContact.contactType === c.contactType && c.sortNum === value) {
          c.sortNum = currentContact.sortNum
          currentContact.sortNum = value
          this.contactList = null
          this.$nextTick(() => {
            this.contactList = contactList
          })
          // this.$set(this.contactList, i, c)
          // this.$set(this.contactList, pindex, currentContact)
        }
      }
    },
    // 处理国家区号输入变更
    handlePhoneNumberUpdata (newValue) {
      this.phoneNumberData = newValue
    },
    handleContactPhoneNumberUpdata (pindex, newValue) {
      if (this.contactList && this.contactList.length > 0) {
        const contact = this.contactList[pindex]
        contact.phoneNumberData = newValue
        this.$set(this.contactList, pindex, contact)
      }
    },
    // 父组件调用校验方法
    async validateBasicForm () {
      // 处理紧急联系人校验
      const emergencyContactComponentPromise = this.$refs.emergencyContactComponent.validateEmergencyContactForm
      const emergencyContactFormData = await emergencyContactComponentPromise()

      const editForm = this.editForm

      const passportComponent = this.$refs.passportComponent
      try {
        this.passportList = await passportComponent.validateForm()
      } catch (e) {
        console.log('Passport validate fail')
        return new Promise((resolve, reject) => { reject() })
      }
      const addressComponent = this.$refs.addressComponent
      this.addressList = addressComponent.getAddressList()
      return new Promise((resolve, reject) => {
        editForm.validateFields((err) => {
          let formIsValid = true
          if (err) {
            formIsValid = false
          }
          if (!this.handleCustomerBirthdayBlur()) {
            formIsValid = false
          }
          // 校验电话号联系方式列表中的电话
          for (let i=0; i<this.contactList.length; i++) {
            const contact = this.contactList[i]
            if (contact.contactType === '2' && contact.phoneNumberData) {
              const phoneNumber = contact.phoneNumberData.phoneNumber
              if (phoneNumber && phoneNumber !== '' && !contact.phoneNumberData.isValid) {
                formIsValid = false
                break
              }
            }
          }
          // 校验电话号码是否有效
          // if (phoneNumberData.phoneNumber && phoneNumberData.phoneNumber !== '' && !phoneNumberData.isValid) {
          //   formIsValid = false
          // }
          if (!formIsValid) {
            reject(new Error('Form validate error.'))
            return
          }
          var formData = editForm.getFieldsValue()
          // 找的默认的联系电话和默认的联系邮箱
          const defaultContactPhone = this.contactList.filter(item => { return (item.contactType === '2' && item.sortNum === 1) })[0]
          const defaultContactEmail = this.contactList.filter(item => { return (item.contactType === '1' && item.sortNum === 1) })[0]

          formData.email = defaultContactEmail.email
          formData.emailTagCode = defaultContactEmail.tagCode

          formData.phoneTagCode = defaultContactPhone.tagCode
          formData.phoneCountryCode = defaultContactPhone.phoneNumberData.countryCode
          formData.phoneCountryCallingCode = defaultContactPhone.phoneNumberData.countryCallingCode
          formData.phoneNumber = defaultContactPhone.phoneNumberData.phoneNumber
          formData.phoneExt = defaultContactPhone.phoneExt
          // 获取邮箱和电话
          const newContactList = []
            for (let i = 0; i < this.contactList.length; i++) {
              const contact = this.contactList[i]
              const newContact = { contactType: contact.contactType, tagCode: contact.tagCode }
              newContact.sortNum = editForm.getFieldValue('contact-' + i + '-sortnum')
              if (newContact.contactType == '1') {
                newContact.email = editForm.getFieldValue('contact-' + i + '-email')
              }
              if (newContact.contactType == '2') {
                const phoneNumberData = contact.phoneNumberData
                newContact.phoneNumberData = null
                if (phoneNumberData) {
                  newContact.phoneCountryCode = phoneNumberData.countryCode
                  newContact.phoneCountryCallingCode = phoneNumberData.countryCallingCode
                  newContact.phoneNumber = phoneNumberData.phoneNumber
                  newContact.phoneExt = editForm.getFieldValue('contact-' + i + '-phoneExt')
                }
              }
              // 获取邮箱和电话
              newContactList.push(newContact)
            }
          // 
          formData.contactList = newContactList
          //
          if (this.addressList) {
            formData.addressList = this.copyDataByJSON(this.addressList)
          } else {
            formData.addressList = []
          }
          if (this.passportList) {
            formData.passportList = this.copyDataByJSON(this.passportList)
          } else {
            formData.passportList = []
          }
          formData.emergencyContact = emergencyContactFormData
          resolve(formData)
          return
        })
      })
    },
    // 处理客人生日失去焦点校验
    handleCustomerBirthdayBlur() {
      const value = this.editForm.getFieldValue('birthday')
      // 日期格式
      const DATE_REG = /^(((0?[13578]|1[02])\/(0?[1-9]|[12]\d|3[01])\/((1[6-9]|[2-9]\d)\d{2}))|((0?[13456789]|1[012])\/(0?[1-9]|[12]\d|30)\/((1[6-9]|[2-9]\d)\d{2}))|(0?2\/(0?[1-9]|1\d|2[0-8])\/((1[6-9]|[2-9]\d)\d{2}))|(0?2\/29\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))$/
      let valid = false
      if (!value || value.length === 0) {
        this.birthdayValid.status = 'error'
        this.birthdayValid.help = 'Please input birthday!'	
        valid = false
      } else {
        if (DATE_REG.test(value)) {
          const bd = moment(value, 'MM/DD/YYYY')
          const now = moment(moment(new Date()).format('MM/DD/YYYY'), 'MM/DD/YYYY')
          const diff = bd.diff(now, 'days')
          if (diff <= 0) {
            this.birthdayValid.status = 'success'
            this.birthdayValid.help = ''
            valid = true
          } else {
            this.birthdayValid.status = 'error'
            this.birthdayValid.help = 'Invalid birthday!',
            valid = false
          }
        } else {
          this.birthdayValid.status = 'error'
          this.birthdayValid.help = 'Invalid date format!',
          valid = false
        }
      }
      return valid
    },
    // 处理了日期变化
    handleDateChange (pindex, name, e) {
      const value = e.target.value
      if (value && value !== '') {
        let newValue = value.replace(/([^0-9|\\/])/, '')
        if (/^[0-9]{2}$/.test(newValue)) {
          newValue = newValue + '/'
        }
        if (/^[0-9]{2}\/[0-9]{2}$/.test(newValue)) {
          newValue = newValue + '/'
        }
        e.target.value = newValue
        console.log('newValue11', newValue)
        this.$nextTick(() => {
          if (newValue.length === 10) {
            if (pindex === null) {
              // 单个生日
              const valid = this.handleCustomerBirthdayBlur()
              if (valid) {
                this.editData.birthday = newValue
                console.log('newValue00', newValue)
              }
            }
          }
        })
      }
    },
    //
    handleContactDelete (pindex) {
      const contactList = this.contactList.filter((_, index) => {
        return pindex != index
      })
      this.contactList = null
      this.$nextTick(() => {
        this.contactList = contactList
      })
    },
    // 监听地址数据变化
    handleAddressChange (newDatas) {
      this.addressList = newDatas
    },
    handlePassportChange (newDatas) {
      this.passportList = newDatas
    }
  },
  computed: {
		// 计算第一个联系邮箱的index
		firstContactEmailIndex () {
			if (this.contactList && this.contactList.length > 0) {
				for (let i=0; i<this.contactList.length; i++) {
					const contact = this.contactList[i]
					if (contact.contactType === '1' && contact.sortNum === 1) {
						return i
					}
				}
				return 0
			} else {
				return 0
			}
		},
		// 计算第一个联系电话的index
		firstContactPhoneIndex () {
			if (this.contactList && this.contactList.length > 0) {
				for (let i=0; i<this.contactList.length; i++) {
					const contact = this.contactList[i]
					if (contact.contactType === '2' && contact.sortNum === 1) {
						return i
					}
				}
				return 0
			} else {
				return 0
			}
		},
		// 联系电话数量
		contactPhoneList () {
			if (this.contactList && this.contactList.length > 0) {
				const filtered = this.contactList.filter(item => { return item.contactType === '2' })
				if (filtered && filtered.length > 0) {
					return filtered
				}
			}
			return []
		},
		// 联系邮箱数量
		contactEmailList () {
			if (this.contactList && this.contactList.length > 0) {
				const filtered = this.contactList.filter(item => { return item.contactType === '1' })
				if (filtered && filtered.length > 0) {
					return filtered
				}
			}
			return []
		}
	},
  watch: {
    initData (val) {
      this.editData = val
      this.loadData()
    }
  }
}
</script>
<style lang="less" scoped>
.phone-number-extension {
  padding-left: 0 !important;
}
.phone-number-extension-input {
  height: 40px;
  border-top-left-radius:0;
  border-bottom-left-radius:0;
}
.phone-number-extension ::v-deep .ant-form-item-label > label::after {
  content: '';
}
.addressList {
  padding-right: 10px;
}
.passportList {
  padding-left: 10px;
}
/deep/ .ant-card-head {
  min-height: 38px;
  line-height: 38px;
}
/deep/.ant-card-head-title {
  padding: 2px 0;
}
/deep/ .ant-card-extra  {
  padding: 2px 0;
}
/deep/ .ant-calendar-picker {
  width: 100%;
}
/deep/ .ant-col .ant-form-item-label {
   font-weight: 600;
}
.contact-phone-box /deep/ .input-tel .input-tel__input{
  border-radius: 0 !important;
}
.cdb-contact-add {
  line-height: 40px;
}
.flex {
  display: flex;
}
/deep/ .phoneExtBox .ant-form-item-label>label:after {
	content: "";
}
/deep/.phone-ext{
  width: 100px;
  height: 40px;
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}
.phone-select-box /deep/ .ant-select-selection--single{
  height: 40px;
}
.phone-select-box /deep/ .ant-select-selection--single .ant-select-selection__rendered{
  line-height: 40px;
}
//.contact-number-text 
/deep/.contact-number-text{
  line-height: 32px;
  height: 32px;
  top: 4px;
}
/deep/.contact-box .ant-form-item-control{
  line-height: 32px !important;
  height: 32px;
}
/deep/ .country-selector__input{
  height: 32px;
  min-height: 32px;
}
/deep/ .country-selector.input-country-selector.has-value .country-selector__label {
  //line-height: 18px;
  display: none;
} 
/deep/ .country-selector{
  line-height: 32px !important;
  height: 32px;
  min-height: 0;
}
// 国旗
/deep/ .country-selector__country-flag {
  top: 10px;
}
// 电话
/deep/ .input-tel__input {
  height: 32px;
  min-height: 32px;
  margin:0;
}
/deep/ .input-tel .input-tel__input{
  margin-left: -1px;
}
/deep/ .phone-ext {
  height: 32px;
  min-height: 32px;
}
/deep/ .input-tel{
  height: 32px;
  min-height: 32px;
}
/deep/ .country-selector.has-value .country-selector__input {
  padding-top: 0;
  border-radius: 0 !important;
  display: block;
}
/deep/ .phone-select-box .ant-select-selection--single {
  height: 32px;
}
/deep/ .phone-select-box .ant-select-selection--single .ant-select-selection__rendered {
  line-height: 32px;
}
/deep/ .input-tel.has-value .input-tel__label{
  line-height: 0; 
  display: none;
}
/deep/ .input-tel.has-value .input-tel__input {
  padding-top: 0px;
  margin:0;
  margin-left: -1px;
}
/deep/ .text-span-title {
  color: rgba(0, 0, 0, 0.85);
  font-size: 14px;
  font-weight: 600;
  line-height: 35px;
}
/deep/ .email-space .ant-form-item-control {
  line-height: 32px;
}
.qx-radius,
.qx-radius /deep/ .ant-select-selection{
  border-radius: 0;
  border-left: 0;
  border-right: 0;
  display: block;
}
.qx-radius-left,
.qx-radius-left /deep/ .ant-select-selection{
  border-radius: 0px 4px 4px 0px;
  display: block;
}
.qx-radius-right,
.qx-radius-right /deep/ .ant-select-selection{
  border-radius: 4px 0px 0px 4px;
  display: block;
}
/deep/ .input-tel.has-error:not(.is-valid) .input-tel__input {
  border-color: #ff4500 !important;
}
.ext-phone .ant-input{
  margin-left: -1px;
  border-left: none;
}
</style>
